"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const toolkit_1 = require("@reduxjs/toolkit");
const businessInformationSlice_1 = require("./businessInformationSlice");
const screenConstants_1 = require("../../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../../hooks/useAppNavigation"));
const navContainer_1 = __importDefault(require("../../../components/navContainer/navContainer"));
const store_1 = require("../../../store");
const utils_1 = require("../../../utils/utils");
const input_1 = __importStar(require("../../../components/input/input"));
const choices_1 = require("../../../utils/choices");
const constants_1 = require("../../../constants/constants");
const checkInput_1 = __importDefault(require("../../../components/checkInput/checkInput"));
const primaryButton_1 = __importDefault(require("../../../components/primaryButton/primaryButton"));
const analytics_1 = require("../../../utils/analytics/analytics");
const BusinessInformation = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const navigation = (0, useAppNavigation_1.default)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const businessData = (0, store_1.useAppSelector)((state) => state.home.business_data);
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [businessName, setBusinessName] = (0, react_1.useState)(businessData ? businessData.business_information.business_name : '');
    const [industry, setIndustry] = (0, react_1.useState)(businessData ? businessData.business_information.business_sector : '');
    const [dateBusinessEstablishment, setDateBusinessEstablishment] = (0, react_1.useState)(businessData ? (0, utils_1.displayDate)(businessData.business_information.business_date_of_incorporation) : '');
    const [averageMoneySales, setAverageMoney] = (0, react_1.useState)(businessData ? businessData.business_information.average_monthly_sales : '');
    const [businessOperation, setBusinessOperations] = (0, react_1.useState)(businessData ? businessData.business_information.business_activities : []);
    const [businessDescription, setBusinessDescription] = (0, react_1.useState)(businessData ? businessData.business_information.business_description : '');
    // SUBMIT FORM DATA
    const submitForm = async () => {
        setIsLoading(true);
        const payload = {
            business_name: businessName.toString(),
            business_sector: industry,
            business_date_of_incorporation: (0, utils_1.databaseDateFormat)(dateBusinessEstablishment.toString()),
            average_monthly_sales: averageMoneySales,
            business_activities: businessOperation,
            business_description: businessDescription.toString(),
        };
        const result = await dispatch((0, businessInformationSlice_1.submitBusinessInformation)(payload));
        logEventWithExtraProperties('api_call', {
            name: 'submit_business_information',
            status: 'submitted',
            location: 'screen_BusinessInformation',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'submit_business_information',
                status: 'success',
                location: 'screen_BusinessInformation',
            });
            setErrors(undefined);
            setIsLoading(false);
            navigation.navigate(screenConstants_1.PROFILE_SCREEN);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'submit_business_information',
                status: 'fail',
                location: 'screen_BusinessInformation',
            });
            setErrors(result.payload);
            setIsLoading(false);
        }
    };
    return (react_1.default.createElement(navContainer_1.default, { errors: errors, isLoading: isLoading, childrenTitle: "Business information", footer: react_1.default.createElement(primaryButton_1.default, { title: "Save", onPress: submitForm, disabled: false, eventName: "businessInformation_save" }) },
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TEXT, label: "Business name", placeholder: "Business name", setValue: setBusinessName, error: (0, utils_1.getError)('business_name', errors), value: businessName }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, choices: choices_1.industryChoices, label: "Industry", value: industry || '', setValue: setIndustry, error: (0, utils_1.getError)('business_sector', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_DATE, label: "Date of business establishment", setValue: setDateBusinessEstablishment, value: dateBusinessEstablishment, error: (0, utils_1.getError)('business_date_of_incorporation', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: `Average monthly sales ( ${constants_1.NAIRA_SYMBOL} )`, choices: choices_1.averageSalesChoices, value: averageMoneySales || '', setValue: setAverageMoney, error: (0, utils_1.getError)('average_monthly_sales', errors) }),
        react_1.default.createElement(checkInput_1.default, { label: "Business operations", choices: choices_1.businessOperationsChoices, setSelected: setBusinessOperations, selected: businessOperation, error: (0, utils_1.getError)('business_activities', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_MULTILINE, label: "Business description", placeholder: "Please add your business description", setValue: setBusinessDescription, error: (0, utils_1.getError)('business_description', errors), value: businessDescription })));
};
exports.default = BusinessInformation;
